import * as THREE from 'three';
import { bakeColored } from '../spikes/threejs/batch';
import { makeSignTexture, mesh, roundedBox } from '../spikes/threejs/helpers';
import type { ParkMaterials } from '../spikes/threejs/materials';
import type { EntityRenderSpec } from './mapParkState';

/** Neutral crate used for production entities that do not yet have a Three.js factory. */
export function createMigrationPlaceholder(mats: ParkMaterials, spec: EntityRenderSpec): THREE.Group {
  const group = new THREE.Group();
  const proto = new THREE.Group();
  proto.add(mesh(roundedBox(1.12, 0.1, 1.12, 0.04), mats.curb, { position: [0, 0.05, 0] }));
  proto.add(mesh(roundedBox(0.98, 0.72, 0.98, 0.08), mats.cream, { position: [0, 0.46, 0] }));
  proto.add(mesh(roundedBox(1.02, 0.08, 1.02, 0.03), mats.wood, { position: [0, 0.86, 0] }));
  proto.add(mesh(new THREE.BoxGeometry(0.08, 0.08, 0.08), mats.gold, { position: [0.36, 0.94, 0.36] }));
  proto.add(mesh(new THREE.BoxGeometry(0.08, 0.08, 0.08), mats.gold, { position: [-0.36, 0.94, 0.36] }));
  proto.add(mesh(new THREE.BoxGeometry(0.72, 0.28, 0.04), mats.wood, { position: [0, 0.58, 0.5] }));
  const baked = new THREE.Mesh(bakeColored(proto), mats.baked);
  baked.castShadow = true;
  baked.receiveShadow = true;
  group.add(baked);

  const tag = `${spec.label} L${spec.level}`.toUpperCase();
  const sign = mesh(
    new THREE.PlaneGeometry(0.68, 0.22),
    new THREE.MeshStandardMaterial({
      map: makeSignTexture(tag.slice(0, 14), '#efe4cf', '#5a3a1c', '#c9a06a'),
      roughness: 0.65,
      side: THREE.DoubleSide,
    }),
    { cast: false, receive: false },
  );
  sign.position.set(0, 0.58, 0.54);
  group.add(sign);
  group.userData.migration = { visual: 'placeholder', kind: spec.kind, slotId: spec.slotId, level: spec.level };
  return group;
}

export function createCarouselLevelMarker(mats: ParkMaterials, level: number): THREE.Group {
  const group = new THREE.Group();
  const proto = new THREE.Group();
  proto.add(mesh(new THREE.CylinderGeometry(0.03, 0.035, 0.72, 6), mats.woodDark, { position: [1.05, 0.36, 0.15] }));
  proto.add(mesh(roundedBox(0.58, 0.28, 0.05, 0.02), mats.wood, { position: [1.05, 0.86, 0.15] }));
  const baked = new THREE.Mesh(bakeColored(proto), mats.baked);
  baked.castShadow = true;
  baked.receiveShadow = false;
  group.add(baked);

  const sign = mesh(
    new THREE.PlaneGeometry(0.52, 0.2),
    new THREE.MeshStandardMaterial({
      map: makeSignTexture(`L${level}`, '#fff6e6', '#5a3a1c', '#e24a4a'),
      roughness: 0.6,
      side: THREE.DoubleSide,
    }),
    { cast: false, receive: false },
  );
  sign.position.set(1.05, 0.86, 0.19);
  group.add(sign);
  return group;
}
